import { memo, useCallback } from 'react';

import { usePush } from '@hh.ru/redux-spa-middleware';
import { H1 } from 'bloko/blocks/header';
import Link, { LinkAppearance } from 'bloko/blocks/link';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { ModelData } from 'bloko/common/tree/types';
import { formatToReactComponent } from 'bloko/common/trl';
import urlParser from 'bloko/common/urlParser';

import translation from 'src/components/translation';
import { useAreasDataProvider } from 'src/hooks/useAreasDataProvider';
import { useOnOffState } from 'src/hooks/useOnOffState';
import { useSelectorNonNullable, useSelector } from 'src/hooks/useSelector';

import RegionSelectorPopup from 'src/components/Price/RegionSelectorPopup';

const TrlKeys = {
    header: 'employer.zp.price.header',
    hint: 'price.region-popup.hint',
    modalHeader: 'employer.zp.price.region-popup.header',
};

const RegionSelector: TranslatedComponent = ({ trls }) => {
    const { pathname, query } = useSelector(({ router }) => router.location);
    const priceRegionTrl = useSelector(({ pricePageMetaInfo }) => pricePageMetaInfo.priceRegionTrl);
    const priceData = useSelectorNonNullable(({ priceData }) => priceData);
    const push = usePush();

    const [popupVisible, showPopup, hidePopup] = useOnOffState(false);

    const dataProvider = useAreasDataProvider(true);

    const updatePriceRegionId = useCallback(
        ({ selectedId }: { selectedId: string | null }) => {
            if (selectedId && query?.priceRegionId !== selectedId) {
                const url = urlParser(pathname);
                url.params = { ...query, priceRegionId: selectedId };
                push(url.href);
            }
            hidePopup();
        },
        [hidePopup, pathname, push, query]
    );

    return (
        <>
            <H1>
                {formatToReactComponent(trls[TrlKeys.header], {
                    '{0}': (
                        <Link appearance={LinkAppearance.Pseudo} onClick={showPopup}>
                            <H1>{priceRegionTrl}</H1>
                        </Link>
                    ),
                })}
            </H1>
            <RegionSelectorPopup
                allPriceRegions={priceData.allPriceRegions as ModelData[]}
                dataProvider={dataProvider}
                defaultSelectedId={priceData.priceRegionId}
                popupVisible={popupVisible}
                title={trls[TrlKeys.modalHeader]}
                onClose={hidePopup}
                onSubmit={updatePriceRegionId}
            />
        </>
    );
};

export default memo(translation(RegionSelector));
